const ef_images = document.querySelectorAll("img");

if (typeof(ef_images) != "undefined" && ef_images != null) {

  for (let i = 0; i < ef_images.length; i++) {
    ef_images[i].removeAttribute("title");
  }
}
